import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Table, Tabs, Chip, Modal, img, fmt } from "./kit";
import { setToast } from "../../util/toast";

const empty = { type: "frame", name: "", coin: 0, days: 30, minLevel: 1, sortOrder: 0, isActive: true, color: "#FFD166" };

// uygulamadaki renkli isim stilleriyle ayni (lib/view/utils/widgets/fancy_name.dart)
const NAME_STYLES = {
  ocean: ["Okyanus mavisi", "#3AA0FF, #7FE7FF, #3A6BFF"],
  royal: ["Kraliyet moru", "#B57BFF, #FF7AD9, #7B5CFF"],
  snow: ["Kar beyazı", "#9CC9F5, #FFFFFF, #BFE3FF"],
  gold: ["Altın", "#FFB02E, #FFE08A, #D98A00"],
  fire: ["Ateş", "#FF3D3D, #FFA63D, #FF3D71"],
  neon: ["Neon", "#3DFFB5, #3DD9FF, #B6FF3D"],
  pink: ["Pembe", "#FF7AB6, #FFC2DE, #FF3D8E"],
  rainbow: ["Gökkuşağı", "#FF5C5C, #FFC94D, #5CE08A, #4DD2FF, #B57BFF"],
};
const typeLabel = {
  frame: "Çerçeve",
  entry: "Giriş efekti",
  name: "Renkli isim",
  bubble: "Sohbet balonu",
  bg: "Profil arka planı",
  room: "Oda teması",
};
const NamePreview = ({ code, text = "AYVO Kullanıcı" }) => (
  <span
    style={{
      fontWeight: 800,
      fontSize: 15,
      padding: "4px 10px",
      borderRadius: 8,
      background: "#111827",
      display: "inline-block",
    }}
  >
    <span
      style={{
        backgroundImage: `linear-gradient(90deg, ${NAME_STYLES[code]?.[1] || "#fff, #fff"})`,
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        color: "transparent",
      }}
    >
      {text}
    </span>
  </span>
);

/// Magaza urunleri (cerceve / giris efekti) ve evlilik yuzukleri.
const StoreRings = () => {
  const [tab, setTab] = useState("store");
  // magaza urunleri ture gore ayri sekmelerde
  const [kind, setKind] = useState("frame");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState(null);
  const [file, setFile] = useState(null);
  const [grant, setGrant] = useState(null);

  const load = async () => {
    setLoading(true);
    const res = tab === "store" ? await api.store() : await api.rings();
    if (res?.status) setRows(tab === "store" ? res.items : res.rings);
    setLoading(false);
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, [tab]);

  const save = async () => {
    const form = new FormData();
    const fields = tab === "store" ? ["type", "name", "coin", "days", "minLevel", "svipMin", "sortOrder", "isActive"] : ["name", "coin", "color", "sortOrder", "isActive"];
    if (tab === "store" && edit.type === "name") {
      if (!NAME_STYLES[edit.image]) return window.alert("Bir renk stili seç.");
      fields.push("image");
    }
    fields.forEach((k) => edit[k] !== undefined && form.append(k, edit[k]));
    if (file && edit.type !== "name") form.append("image", file);
    const res = tab === "store" ? await api.saveStore(edit._id, form) : await api.saveRing(edit._id, form);
    if (!res?.status) return window.alert(res?.message || "Kaydedilemedi");
    setEdit(null);
    setFile(null);
    load();
  };

  const toggle = async (r) => {
    const form = new FormData();
    form.append("isActive", !r.isActive);
    tab === "store" ? await api.saveStore(r._id, form) : await api.saveRing(r._id, form);
    load();
  };

  const doGrant = async () => {
    if (!grant.code) return window.alert("Kullanıcı ID yaz.");
    const res = await api.grantStore({ itemId: grant.item._id, code: grant.code.trim(), days: Number(grant.days), equip: true });
    window.alert(res?.message || (res?.status ? "Verildi" : "Verilemedi"));
    if (res?.status) setGrant(null);
  };

  const field = (label, key, type = "text", extra = {}) => (
    <div style={{ marginBottom: 10 }}>
      <label style={{ fontSize: 12, color: "#6B7280" }}>{label}</label>
      <input className="form-control" type={type} value={edit?.[key] ?? ""} onChange={(e) => setEdit({ ...edit, [key]: e.target.value })} {...extra} />
    </div>
  );

  return (
    <>
      <PageHead
        title="Mağaza & Yüzükler"
        sub="Kullanıcıların coinle aldığı profil çerçeveleri, giriş efektleri ve evlilik yüzükleri."
        right={
          <button className="btn btn-primary" onClick={() => setEdit({ ...empty, type: tab === "store" ? kind : empty.type })}>
            Yeni ekle
          </button>
        }
      />
      <Tabs value={tab} onChange={setTab} tabs={[["store", "Mağaza ürünleri"], ["rings", "Yüzükler"]]} />
      {tab === "store" && (
        <div className="d-flex" style={{ gap: 6, flexWrap: "wrap", margin: "10px 0 12px" }}>
          {Object.entries(typeLabel).map(([k, label]) => {
            const count = rows.filter((r) => r.type === k).length;
            const on = kind === k;
            return (
              <button
                key={k}
                onClick={() => setKind(k)}
                className="btn btn-sm"
                style={{
                  borderRadius: 99,
                  padding: "6px 14px",
                  fontWeight: 600,
                  background: on ? "#0A84FF" : "#fff",
                  color: on ? "#fff" : "#334155",
                  border: on ? "1px solid #0A84FF" : "1px solid #E2E8F0",
                }}
              >
                {label} <span style={{ opacity: 0.7, marginLeft: 4 }}>{count}</span>
              </button>
            );
          })}
        </div>
      )}
      <Table
        loading={loading}
        head={tab === "store" ? ["Görsel", "Ad", "Tür", "Fiyat", "Süre", "Min. seviye", "Durum", ""] : ["Görsel", "Ad", "Fiyat", "Renk", "Durum", ""]}
        rows={(tab === "store" ? rows.filter((r) => r.type === kind) : rows).map((r) => (
          <tr key={r._id}>
            <td>{r.type === "name" ? <NamePreview code={r.image} text={r.name} /> : r.image ? (/\.svga$/i.test(r.image) ? <span style={{ background: "#EEF2FF", color: "#2F5FD0", borderRadius: 8, padding: "4px 10px", fontWeight: 700, fontSize: 12 }}>SVGA ▶</span> : <img src={img(r.image)} alt="" style={{ height: 40 }} />) : "—"}</td>
            <td>
              <b>{r.name}</b>
            </td>
            {tab === "store" && <td>{typeLabel[r.type] || r.type}</td>}
            <td>{fmt(r.coin)} coin</td>
            {tab === "store" ? (
              <>
                <td>{r.days} gün</td>
                <td>{r.minLevel}{r.svipMin > 0 ? ` · SVIP${r.svipMin}` : ""}</td>
              </>
            ) : (
              <td>
                <span style={{ display: "inline-block", width: 18, height: 18, borderRadius: 9, background: r.color }} /> {r.color}
              </td>
            )}
            <td>
              <button className={`btn btn-sm ${r.isActive ? "btn-outline-success" : "btn-outline-secondary"}`} onClick={() => toggle(r)}>
                {r.isActive ? "Satışta" : "Kapalı"}
              </button>
            </td>
            <td>
              <button className="btn btn-sm btn-outline-primary mr-1" onClick={() => setEdit({ ...r })}>
                Düzenle
              </button>
              {tab === "store" && (
                <button className="btn btn-sm btn-outline-success" onClick={() => setGrant({ item: r, code: "", days: r.days })}>
                  Kullanıcıya ver
                </button>
              )}
            </td>
          </tr>
        ))}
      />
      <Modal open={!!edit} title={edit?._id ? "Düzenle" : "Yeni ekle"} onClose={() => setEdit(null)}>
        {edit && (
          <>
            {tab === "store" && (
              <div style={{ marginBottom: 10 }}>
                <label style={{ fontSize: 12, color: "#6B7280" }}>Tür</label>
                <select className="form-control" value={edit.type} onChange={(e) => setEdit({ ...edit, type: e.target.value })}>
                  <option value="frame">Profil çerçevesi</option>
                  <option value="entry">Giriş efekti</option>
                  <option value="name">Renkli kullanıcı adı</option>
                  <option value="bubble">Sohbet balonu</option>
                  <option value="bg">Profil arka planı</option>
                  <option value="room">Oda teması</option>
                </select>
              </div>
            )}
            {tab === "store" && edit.type === "name" && (
              <div style={{ marginBottom: 10 }}>
                <label style={{ fontSize: 12, color: "#6B7280" }}>Renk stili (uygulamada kayan ışıltılı görünür)</label>
                <div className="d-flex flex-wrap" style={{ gap: 8, marginTop: 4 }}>
                  {Object.entries(NAME_STYLES).map(([code, [label]]) => (
                    <button
                      key={code}
                      type="button"
                      onClick={() => setEdit({ ...edit, image: code, name: edit.name || label })}
                      style={{ border: edit.image === code ? "2px solid #2F5FD0" : "2px solid transparent", borderRadius: 10, background: "transparent", padding: 2 }}
                    >
                      <NamePreview code={code} text={label} />
                    </button>
                  ))}
                </div>
              </div>
            )}
            {field("Ad", "name")}
            {field("Fiyat (coin)", "coin", "number", { min: 0 })}
            {tab === "store" ? (
              <>
                {field("Süre (gün)", "days", "number", { min: 1 })}
                {field("Minimum seviye", "minLevel", "number", { min: 1 })}
                {field("SVIP'e özel (0 = herkes, 1-10 = en az bu SVIP)", "svipMin", "number", { min: 0, max: 10 })}
              </>
            ) : (
              field("Renk", "color", "color")
            )}
            {field("Sıra", "sortOrder", "number")}
            {edit.type !== "name" && (
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 12, color: "#6B7280" }}>Görsel (PNG / SVGA)</label>
                <input
                  className="form-control"
                  type="file"
                  onChange={(e) => {
                    // accept listesi .svga dosyasini macOS'ta soluklastiriyordu
                    const f = e.target.files?.[0] || null;
                    if (f && !/\.(svga|png|jpe?g|webp|gif)$/i.test(f.name)) {
                      setToast("error", "PNG ya da SVGA dosyası seç");
                      e.target.value = "";
                      return setFile(null);
                    }
                    setFile(f);
                  }}
                />
                {edit.image && !file && edit.type !== "name" ? (/\.svga$/i.test(edit.image) ? <div style={{ marginTop: 8 }}><span style={{ background: "#EEF2FF", color: "#2F5FD0", borderRadius: 8, padding: "4px 10px", fontWeight: 700, fontSize: 12 }}>SVGA ▶</span></div> : <img src={img(edit.image)} alt="" style={{ height: 60, marginTop: 8 }} />) : null}
                <div style={{ fontSize: 12, color: "#64748B", marginTop: 6 }}>Çerçeve için SVGA (hareketli) ya da şeffaf PNG. Kare olmalı, avatar ortada boş kalmalı.</div>
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center">
              {edit._id ? <Chip kind={edit.isActive ? "ok" : "wait"}>{edit.isActive ? "Satışta" : "Kapalı"}</Chip> : <span />}
              <button className="btn btn-primary" onClick={save} disabled={!edit.name}>
                Kaydet
              </button>
            </div>
          </>
        )}
      </Modal>
      <Modal open={!!grant} title="Kullanıcıya ver" onClose={() => setGrant(null)}>
        {grant && (
          <>
            <div style={{ marginBottom: 10 }}>
              {grant.item.type === "name" ? <NamePreview code={grant.item.image} text={grant.item.name} /> : <b>{grant.item.name}</b>}
              <div style={{ fontSize: 12, color: "#6B7280", marginTop: 6 }}>Coin düşülmez. Kullanıcıya eklenir ve otomatik kuşanılır.</div>
            </div>
            <div style={{ marginBottom: 10 }}>
              <label style={{ fontSize: 12, color: "#6B7280" }}>Kullanıcı ID</label>
              <input className="form-control" value={grant.code} placeholder="ör. 2568689" onChange={(e) => setGrant({ ...grant, code: e.target.value })} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, color: "#6B7280" }}>Süre (gün) — 0 yazarsan kalıcı</label>
              <input className="form-control" type="number" min={0} value={grant.days} onChange={(e) => setGrant({ ...grant, days: e.target.value })} />
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn btn-success" onClick={doGrant}>
                Ver
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default StoreRings;
